import React from 'react';
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';

import PinnedFiltersSettings from './PinnedFiltersSettings';

const PinnedFiltersModal = ({
  isOpen,
  close,
}: {
  isOpen: boolean;
  close: () => void;
}) => (
  <ModalTransition>
    {isOpen && (
      <ModalDialog
        onClose={close}
        shouldScrollInViewport={false}
        autoFocus={false}
      >
        <PinnedFiltersSettings close={close} />
      </ModalDialog>
    )}
  </ModalTransition>
);

export default PinnedFiltersModal;
